import React, { useState, useEffect } from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from "chart.js";
import { Bar, Doughnut } from "react-chartjs-2";
import Sidebar from "./Sidebar";
import "./Admin.css"; // Import CSS file
import api,{ API_ENDPOINTS } from "../config";

// Register required Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

const AdminDashboard = () => {
  const [dashboardData, setDashboardData] = useState({
    totalOrders: 0,
    productsListed: 0,
    completedOrders: 0,
    pendingOrders: 0,
    canceledOrders: 0,
    processingOrders: 0,
    totalRevenue: 0,
  });

    const [currentTime, setCurrentTime] = useState(new Date());

  // Update the time every second
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer); // Cleanup the interval on component unmount
  }, []);

   // Fetch data from API
  useEffect(() => {
    const fetchData = async () => {
      try {
       const response = await api.get(API_ENDPOINTS.GET_TOTAL_ORDERS); 
        const data = response.data;
        console.log("Fetched total orders:", data); 

        // Update the dashboard data with the fetched totalOrders
        setDashboardData((prevData) => ({
          ...prevData,
          totalOrders: data // Assuming the API returns { totalOrders: 120 }
        }));
      } catch (error) {
        console.error("Error fetching total orders:", error);
      }
    };

    fetchData();
  }, []);
 
  useEffect(() => {
  const fetchProductsListed = async () => {
    try {
      const response = await api.get(API_ENDPOINTS.GET_TOTAL_PACKAGES); 
      const data = response.data;

      // Update the dashboard data with the fetched productsListed
      setDashboardData((prevData) => ({
        ...prevData,
        productsListed: data, 
      }));
    } catch (error) {
      console.error("Error fetching products listed:", error);
    }
  };

  fetchProductsListed();
}, []);

useEffect(() => {
  const fetchOrderStatuses = async () => {
    try {
      const response = await api.get(API_ENDPOINTS.GET_STATUS_COUNTS); 
      const data = response.data;

      // Update the dashboard data with the fetched order statuses
      setDashboardData((prevData) => ({
        ...prevData,
        completedOrders: data.Completed, 
        pendingOrders: data.Pending,     
        canceledOrders: data.Cancelled,
        processingOrders: data.Processing,   
      }));
    } catch (error) {
      console.error("Error fetching order statuses:", error);
    }
  };

  fetchOrderStatuses();
}, []);
  
useEffect(() => {
  const fetchTotalRevenue = async () => {
    try {
      const response = await api.get(API_ENDPOINTS.GET_TOTAL_REVENUE); 
      const data = response.data;

      // Update the dashboard data with the fetched totalRevenue
      setDashboardData((prevData) => ({
        ...prevData,
        totalRevenue: data.totalAmount, 
      }));
    } catch (error) {
      console.error("Error fetching total revenue:", error);
    }
  };

  fetchTotalRevenue();
}, []);


  // Data for the Doughnut Chart
  const doughnutData = {
    labels: ["Completed Orders", "Pending Orders", "Canceled Orders", "Processing Orders"],
    datasets: [
      {
        data: [
          dashboardData.completedOrders,
          dashboardData.pendingOrders,
          dashboardData.canceledOrders,
          dashboardData.processingOrders
        ],
        backgroundColor: ["#4caf50", "#ff9800", "#f44336","#2196f3"], // Colors for each section
        hoverBackgroundColor: ["#388e3c", "#fb8c00", "#e53935"],
      },
    ],
  };

  // Data for the Bar Chart
  const barData = {
    labels: ["Total Revenue"],
    datasets: [
      {
        label: "Revenue (BIRR)",
        data: [dashboardData.totalRevenue],
        backgroundColor: ["#3f51b5"],
        hoverBackgroundColor: ["#303f9f"],
      },
    ],
  };

  return (
    <div className="admin-container">
      <Sidebar />
      <div className="dashboard-content">
       <div className="header">
       
          <div>
            <h2>Welcome to the Admin Dashboard</h2>
        
          
    
          </div>
             <div className="clock">
            {currentTime.toLocaleDateString()} {currentTime.toLocaleTimeString()}
          </div>
         
        </div>

             <div className="divider"></div>
      
        <div className="analytics-container">
          <div className="analytics-card">
            <h3>Total Orders</h3>
            <p className="analytics-value">{dashboardData.totalOrders}</p>
          </div>
          <div className="analytics-card">
            <h3>Products Listed</h3>
            <p className="analytics-value">{dashboardData.productsListed}</p>
          </div>
        </div>

        <div className="charts-container ">
          <div className="chart small-chart-container ">
            <h3>Order Status</h3>
            <Doughnut className="small-chart" data={doughnutData}  options={{
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          font: {
            size: 12, // Adjust font size for legend
          },
        },
      },
    },
  }} />
          </div>
          <div className="chart small-chart-container">
            <h3>Total Revenue</h3>
            <Bar data={barData} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;